import { ref, onMounted } from 'vue';
import bondService from '@/service/bondService';

export function useCreditIssuance() {
  // States
  const isLoading = ref(false);
  const currentCreditType = ref('PUBLIC');
  const selectedMonths = ref(3); // 3개월 고정
  const issuanceData = ref([]);
  const creditTypes = ref([]);

  // Load credit types from API
  const loadCreditTypes = async () => {
    try {
      const response = await bondService.getCreditBondTypes();
      creditTypes.value = response || [];

      // Set first type as default if available
      if (creditTypes.value.length > 0) {
        currentCreditType.value = creditTypes.value[0].type;
      }
    } catch (error) {
      console.error('크레딧 타입 로드 중 오류:', error);
      // Fallback to default types
      creditTypes.value = [
        { type: 'PUBLIC', title: '공기업' },
        { type: 'BANK', title: '은행' },
        { type: 'CREDIT_FINANCE', title: '신용금융' },
        { type: 'COMPANY', title: '일반기업' },
      ];
      currentCreditType.value = 'PUBLIC';
    }
  };

  // Load issuance data
  const loadIssuanceData = async () => {
    if (!currentCreditType.value) return;

    isLoading.value = true;
    try {
      const response = await bondService.getCreditIssuance(currentCreditType.value, selectedMonths.value);
      issuanceData.value = response || [];
    } catch (error) {
      console.error('발행정보 로드 중 오류:', error);
      issuanceData.value = [];
    } finally {
      isLoading.value = false;
    }
  };

  // Select credit type and reload data
  const selectCreditType = async type => {
    currentCreditType.value = type;
    await loadIssuanceData();
  };

  // Get credit type name by type
  const getCreditTypeName = type => {
    const creditType = creditTypes.value.find(ct => ct.type === type);
    return creditType ? creditType.title : type;
  };

  // Initialize
  onMounted(async () => {
    await loadCreditTypes();
    await loadIssuanceData();
  });

  return {
    // States
    isLoading,
    currentCreditType,
    issuanceData,
    creditTypes,

    // Methods
    loadCreditTypes,
    loadIssuanceData,
    selectCreditType,
    getCreditTypeName,
  };
}
